import { configureStore } from "@reduxjs/toolkit";
import thunkMiddleware from "redux-thunk";

import authSlice from "./slice/authSliceLogin/authSliceLogin";
import routingSlice from "./slice/routingSlice/routingSlice";
import profileSlice from "./slice/profileSlice/profileSlice";
import applicationCreateSlice from "./slice/applicationCreateSlice/applicationCreateSlice";
import banksSlice from "./slice/banksSlice/banksSlice";
import applicationsAllSlice from "./slice/applicationsSlice/applicationsSlice";
import requestAppSlise from "./slice/requestAppSlise/requestAppSlise";
import listAgentSlice from "./slice/listAgentSlice/listAgentSlice";
import listClientSlice from "./slice/listClientSlice/listClientSlice";
import applicationDataToBankSlice from "./slice/applicationDataToBankSlice/applicationDataToBankSlice";
import { api } from "./api/apiCore";
import notificationsSlice from "./slice/notificationsSlice/notificationsSlice";
import listClientForAgentSlice from "./slice/listClientForAgentSlice/listClientForAgentSlice";
import listManagerSlice from "./slice/listManagerSlice/listManagerSlice";
import modalSlice from "./slice/modalSlice/modalSlice";
import adminAgentInfoSlice from "./slice/adminAgentInfoSlice/AdminAgentInfoSlice";
import adminAgentIndividualInfoSlice from "./slice/adminAgentIndividualInfoSlice/AdminAgentIndividualInfoSlice";
import adminCreateManagerSlice from "./slice/adminManagerSlice/adminManagerSlice";
import themeSlice from "./slice/themeSlice/themeSlice";

const store = configureStore({
  reducer: {
    themeSlice,
    authSlice: authSlice,
    routingSlice: routingSlice,
    profileSlice: profileSlice,
    applicationsAllSlice: applicationsAllSlice,
    applicationDataToBank: applicationDataToBankSlice,
    applicationCreateSlice: applicationCreateSlice,
    banksSlice: banksSlice,
    requestAppSlise: requestAppSlise,
    listAgentSlice: listAgentSlice,
    listClientSlice: listClientSlice,
    listManagerSlice: listManagerSlice,
    notificationsSlice: notificationsSlice,
    listClientForAgentSlice: listClientForAgentSlice,
    modalSlice: modalSlice,
    adminAgentInfoSlice: adminAgentInfoSlice,
    adminAgentIndividualInfoSlice: adminAgentIndividualInfoSlice,
    adminManagerInfoSlice: adminCreateManagerSlice,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware(),
    api.middleware,
    thunkMiddleware,
  ],
  devTools: process.env.REACT_APP_IS_BUILD !== "PRODUCTION",
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
